import { mergeAttributes } from '@tiptap/core';
import { Highlight } from '@tiptap/extension-highlight';

// Tiptap's default Highlight renders as <mark>, which Gmail strips entirely (not on its allowed-tag list)
// and Outlook's Word renderer refuses to style. Serialising as <span style="background-color: …"> gives us
// universal email-client support. parseHTML still accepts <mark> (default) so pre-existing content and
// pasted-in Google Docs highlights survive, and adds a <span style="background-color"> rule so drafts saved
// from this editor round-trip cleanly.
export const EmailSafeHighlight = Highlight.extend({
  parseHTML() {
    return [
      { tag: 'mark' },
      {
        tag: 'span',
        getAttrs: (node) => {
          const element = node as HTMLElement;
          const bg = element.style.backgroundColor;
          if (!bg) { return false; }
          // A textStyle mark with only `color` set would not match here (no background-color), so this
          // rule is unambiguous vs the font-color TextStyle span.
          return this.options.multicolor ? { color: bg } : {};
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ['span', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  }
});
